/* app event enums */

export const APP_INITIALIZED = 'app/APP_INITIALIZED';
export const AUTHENTICATION_SUCCESS = 'app/AUTHENTICATION_SUCCESS';
export const AUTHENTICATION_ERROR = 'app/AUTHENTICATION_ERROR';
export const CHAT_CLIENT_CONNECTED = 'app/CHAT_CLIENT_CONNECTED';
export const CHAT_CLIENT_DISCONNECTED = 'app/CHAT_CLIENT_DISCONNECTED';
export const CHAT_CLIENT_RECONNECT = 'app/CHAT_CLIENT_RECONNECT';
export const SERVER_ERROR = 'app/SERVER_ERROR';
export const PROACTIVE_TRIGGERED = 'app/PROACTIVE_TRIGGERED';

export const appEventTypes = {
  APP_INITIALIZED,
  AUTHENTICATION_SUCCESS,
  AUTHENTICATION_ERROR,
  CHAT_CLIENT_CONNECTED,
  CHAT_CLIENT_DISCONNECTED,
  CHAT_CLIENT_RECONNECT,
  SERVER_ERROR,
  PROACTIVE_TRIGGERED,
};

/* app events */

export const appInitialized = () => ({ type: APP_INITIALIZED });
export const chatClientConnected = () => ({ type: CHAT_CLIENT_CONNECTED });
export const chatClientDisconnected = () => ({ type: CHAT_CLIENT_DISCONNECTED });
export const chatClientReconnect = () => ({ type: CHAT_CLIENT_RECONNECT });
export const clientAuthenticationSuccess = payload => ({ type: AUTHENTICATION_SUCCESS, payload });
export const clientAuthenticationError = payload => ({ type: AUTHENTICATION_ERROR, payload });
export const serverError = payload => ({ type: SERVER_ERROR, payload });
export const proactiveTriggered = () => ({ type: PROACTIVE_TRIGGERED });

export default {
  appInitialized,
  chatClientConnected,
  chatClientDisconnected,
  chatClientReconnect,
  clientAuthenticationSuccess,
  clientAuthenticationError,
  serverError,
  proactiveTriggered,
};
